import { Button, Form, Input, Popconfirm, Space, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Customer } from '@/types'
import { GetOperatorResponse } from '@/types/apis/operators/GetOperatorResponse'
import { UpdateOperatorRequest } from '@/types/apis/operators/UpdateOperatorRequest'

export type UpdateOperatorFormValue = UpdateOperatorRequest

type Props = {
  operatorId: number
  updateLoading: boolean
  getOperatorResponse: GetOperatorResponse | undefined
  getLoading: boolean
  operatorData?: { name: string; code: string }
  onSubmit: (formValues: UpdateOperatorRequest) => void
  onDelete: (id: Customer['id']) => void
}

const UpdateOperatorForm = ({
  getOperatorResponse,
  operatorId,
  updateLoading,
  getLoading,
  onSubmit,
  onDelete,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [form] = Form.useForm<UpdateOperatorRequest>()
  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState<Record<string, boolean>>({})

  useEffect(() => {
    if (getOperatorResponse) {
      form.setFieldsValue(getOperatorResponse)
    }
  }, [form, getOperatorResponse])

  return (
    <Spin spinning={getLoading}>
      <Form layout="vertical" onFinish={onSubmit} form={form}>
        <Form.Item
          label={t('components.pages.operators.update.form.code')}
          name="code"
          rules={[{ required: true, message: t('components.pages.operators.update.form.requireCode') }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={t('components.pages.operators.update.form.name')}
          name="name"
          rules={[{ required: true, message: t('components.pages.operators.update.form.requireName') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button type="primary" htmlType="submit" loading={updateLoading}>
              {t('components.pages.operators.update.form.update')}
            </Button>
            <Popconfirm
              id={operatorId.toString()}
              visible={!!visibleConfirmDelete[operatorId]}
              title={t('components.pages.announcements.list.table.confirmDelete')}
              okText={t('common.yes')}
              cancelText={t('common.no')}
              onCancel={() => setVisibleConfirmDelete({})}
              onConfirm={async () => {
                await onDelete(operatorId)
                navigate('/laundry')
              }}
            >
              <Button danger onClick={() => setVisibleConfirmDelete({ [operatorId]: true })}>
                {t('components.pages.announcements.list.table.delete')}
              </Button>
            </Popconfirm>
          </Space>
        </Form.Item>
      </Form>
    </Spin>
  )
}

UpdateOperatorForm.displayName = 'UpdateOperatorForm'
export default UpdateOperatorForm
